import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { InteractService } from 'app/BaseFramework/core/services/interact/interact.service';
import { ApiRequestService } from 'app/BaseFramework/core/http/api-request.service';
import { CommonUtilty } from 'app/BaseFramework/core/utilities/commonUtility';
import { ValidationUtilService } from 'app/BaseFramework/core/services/validations/validationsUtil.service';
import { AppMetadataHandler } from 'app/BaseFramework/configs/app-metadata.handler';
import { LookupDataService } from 'app/BaseFramework/core/http/lookupdata.service';
import { MetadataService } from 'app/BaseFramework/core/http/metadata.service';
import { TechnicalTranslatePipe } from 'app/BaseFramework/shared/custom-pipes';
import { Subject, zip } from 'rxjs';
import { AsyncSubject, of } from 'rxjs';
import { RuleEngineService } from 'app/BaseFramework/core/http/ruleengine.service';
import { DataTransformService } from 'app/ViewModules/shared-services';
class RuleDataMapper {
  dataType = null;
  dataTypeCd = null;
  dataTypeOrder = null;
  data = null;
  columnData = null;
  align = null;
  expressionUiCondition = null;
}
class tagFormat {
  name : string;
  color : string;
  info : string
}
interface Condition {
  logicalOperator?: string;
  rhs?: any;
  lhs?: any;
  relationalOperator?: string;
  nestedWhereCondition?: Condition;
}

interface Expression {
  parentEntity: string;
  findAny?: any;
  findAll?: any;
  findMax?: string;
  findMin?: string;
  findCount?: string;
  findSum?: string;
  findAverage?: string;
  whereCondition: Condition;
  ifTrue: Array<Condition>;
  ifFalse: Array<Condition>;
}
@Component({
  selector: 'app-rule-audit',
  templateUrl: './rule-audit.component.html',
  styleUrls: ['./rule-audit.component.scss'],
  providers: [TechnicalTranslatePipe]
})
export class RuleAuditComponent implements OnInit {

  constructor(private apiRequestService: ApiRequestService,
    private commonUtilty: CommonUtilty,
    private appMetadataHandler: AppMetadataHandler,
    public metadataService: MetadataService,
    public technicalTranslatePipe: TechnicalTranslatePipe,
    private lookupDataService: LookupDataService,
    private ruleEngineService : RuleEngineService,
    public dataTransformService: DataTransformService) { }

  _viewRuleData: any;
  ruleData: any;
  ruleContext: any;
  computationalRules: any = []
  isComputationRule = false;
  @Output() isView = new EventEmitter<any>();
  @Input() showDetails: boolean = true;
  @Input()
  set viewRuleArr(ruleData) {
    this.fetchComputationalSteps(ruleData);
    // let ruleDO: any
    // if (ruleData && this.commonUtilty.isArrayIterable(ruleData.rulesList)) {
    //   ruleDO = ruleData.rulesList.find(item => item.versionId == this.viewRuleVersion);

    //   if(!ruleDO){
    //     ruleDO = ruleData.rulesList.find(item => true);
    //   }

    //   if (ruleData.rulesList && ruleDO && ruleDO.ruleType != 'PRECONDITION') {
    //     if (ruleData.rulesList && ruleDO && (ruleDO.ruleCategory != 'RATETABLE' && ruleDO.ruleCategory != 'RATETABLE_DEFAULT')) {
    //       this.isComputationRule = true
    //       this.fetchAttributes()
    //       this._viewRuleData = [ruleDO];
    //       this.ruleContext = ruleData.context;
    //       this.ruleData = ruleDO;
    //       this.computationalRules = ruleData.rulesList.slice(1);
    //       this.setActionType()
    //       //this.transformData();
    //     } else if (ruleData && ruleData.rulesList) {
    //       this.isComputationRule = false
    //       this._viewRuleData = [ruleDO];
    //       this.ruleContext = ruleData.context;
    //       this.ruleData = ruleDO;
    //       this.transformData();
    //     }
    //     this.fetchAttributes();
    //   } else {
    //     if (ruleData && this.commonUtilty.isArrayIterable(ruleData.rulesList) && ruleData.rulesList.length > 1) {
    //       this.isComputationRule = true
    //       this.fetchAttributes()
    //       this._viewRuleData = [ruleDO];
    //       this.ruleContext = ruleData.context;
    //       this.ruleData = ruleDO;
    //       this.computationalRules = ruleData.rulesList.slice(1);
    //       this.setActionType()
    //     } else {
    //       this.isComputationRule = false
    //       this._viewRuleData = [ruleDO];
    //       this.ruleContext = ruleData.context;
    //       this.ruleData = ruleDO;
    //       this.transformData();
    //     }
    //     this.fetchAttributes();
    //   }

    // }
  }

  get viewRuleArr() {
    return this._viewRuleData;
  }

  private _dataAvailable = [];
  public get dataAvailable() {
    try {
      return this._dataAvailable.filter(element => !element.isUsedFlag);
    } catch (error) {
      return [];
    }

  }
  public set dataAvailable(value) {
    this._dataAvailable = value;
  }

  private _functionTypeMap;
  public get functionTypeMap() {
    let map = {}
    this.functionTypes.forEach(e => map[e.id] = e.value);
    return map
  }
  public set functionTypeMap(value) {
    this._functionTypeMap = value;
  }
    
  itemType = 'default';
  functionTypes = [
    { id: "#FN_NumberFunctionUtility", value: "Number Function", type: this.itemType, itemType: 'MATHEMATICAL_FUNCTION' },
    { id: "#FN_DateFunctionUtility", value: "Date Function", type: this.itemType, itemType: 'DATE_FUNCTION' },
  ]
  @Input() viewAuditRuleArr = [];
  @Input() mode;
  @Input() viewRuleVersion;
  auditPanelOpen = false;
  auditPanel(status) { this.auditPanelOpen = !!status; };
  page = 1;

  pageChange(i) { this.page = i }

  lookupsToBind = ['comboVocabularyCd', 'payoutRateTableCd', 'computationStepType', 'RuleEntityCd', 'StepVariable', 'RuleSetType', 'entityMasterCd','prdBasePlanCd','contextRuleCd']
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  ngOnInit() {
    console.log("lookup cache", JSON.stringify(this.lookupDataService.lookupCacheMap));
    console.log("rule mode", this.mode);
    this.getPayoutRateLookup();
    this.getRuleHistoryData();
    this.fetchAttributes();
    this.fetchAllVocabularies();
    this.tagsList();
    // if(this.ruleData){
    //   this.RefreshLookups(this.ruleData.ruleActionList);
    //   this.RefreshLookups(this.ruleData.ruleConditionList);
    // }
  }
  tags : any[] =[]
  tagsList(){
    this.tags = []
    if(this.viewRuleArr && this.viewRuleArr[0] && this.viewRuleArr[0]?.productFamilyCSV){
      let tag = new tagFormat()
      tag.name = this.viewRuleArr[0]?.productFamilyCSV;
      tag.color = 'blue';
      tag.info = 'The product line field identifies the specific line of business, such as Health, to which the rule belongs. It helps align the rule with the appropriate product context.'
      this.tags = this.commonUtilty.uniquePushInArray(this.tags,tag,'name');
    }
    if(this.viewRuleArr && this.viewRuleArr[0] && this.viewRuleArr[0]?.workflowStatusCd){
      let tag = new tagFormat()
      tag.name = this.viewRuleArr[0]?.workflowStatusCd;
      if(this.viewRuleArr[0]?.workflowStatusCd == 'PUBLISH')
        tag.color = 'green';
      else tag.color = 'orange';
      this.tags = this.commonUtilty.uniquePushInArray(this.tags,tag,'name');
    }
  }

  payoutRateLookupList: any = []
  getPayoutRateLookup() {
    this.lookupDataService.getLookup('calculationRuleCd').subscribe(resp => {
      if (resp && this.commonUtilty.isArrayIterable(resp))
        this.payoutRateLookupList = resp
    })
  }

  fetchComputationalSteps(ruleData) {     
    let ruleDO: any
    if (ruleData && this.commonUtilty.isArrayIterable(ruleData.rulesList)) {
      ruleDO = ruleData.rulesList.find(item => item.versionId == this.viewRuleVersion);

      if (!ruleDO) {
        ruleDO = ruleData.rulesList.find(item => true);
      }

      if (ruleData.rulesList && ruleDO && ruleDO.ruleType != 'PRECONDITION') {
        if (ruleData.rulesList && ruleDO && (ruleDO.ruleCategory != 'RATETABLE' && ruleDO.ruleCategory != 'RATETABLE_DEFAULT')) {
          this.isComputationRule = true
          this.fetchAttributes()
          this._viewRuleData = [ruleDO];
          this.ruleContext = ruleData.context;
          this.ruleData = ruleDO;
          this.computationalRules = ruleData.rulesList.slice(1);
          this.setActionType()
          //this.transformData();
        } else if (ruleData && ruleData.rulesList) {
          this.isComputationRule = false
          this._viewRuleData = [ruleDO];
          this.ruleContext = ruleData.context;
          this.ruleData = ruleDO;
          this.transformData();
        }
        this.fetchAttributes();
      } else {
        if (ruleData && this.commonUtilty.isArrayIterable(ruleData.rulesList) && ruleData.rulesList.length > 1) {
          this.isComputationRule = true
          this.fetchAttributes()
          this._viewRuleData = [ruleDO];
          this.ruleContext = ruleData.context;
          this.ruleData = ruleDO;
          this.computationalRules = ruleData.rulesList.slice(1);
          this.setActionType()
        } else {
          this.isComputationRule = false
          this._viewRuleData = [ruleDO];
          this.ruleContext = ruleData.context;
          this.ruleData = ruleDO;
          this.transformData();
        }
        this.fetchAttributes();
      }

    }
  }
  auditVersionId: any = null;
  viewRuleAuditData : any = null;
  getRuleHistoryData(data?, versionId?) {
    if (this.commonUtilty.isArrayIterable(this.viewAuditRuleArr)) {
      this.isLoading = true;
      // this.viewRuleArr = [];
      if (!data) {
        this.viewAuditRuleArr = this.commonUtilty.sortObject('id', this.viewAuditRuleArr, 'desc')
        this.selectedItem = this.viewAuditRuleArr.find(item => true);
        this.auditVersionId = this.selectedItem['entityVersionId']
      } else {
        this.selectedItem = data;
        this.auditVersionId = versionId
      }
      if (this.selectedItem['id']) {
        this.apiRequestService.getCallWithAPIMapper('auditFetchById/' + this.selectedItem['id'])
          .subscribe(entityCode => {
            // this._viewRuleData = [];
            let auditRuleData = [];
            console.log(entityCode);
            if (entityCode && Object.keys(entityCode).length) {
              let data = this.commonUtilty.deepCopy([JSON.parse(entityCode.auditDataList[0].entityJson)]);
              // this._viewRuleData = this.commonUtilty.deepCopy(data[0]?.rulesList);         //As _viewRuleData is used to rendered ruleData on UI. only one rule needs to be assigned.
              auditRuleData = this.commonUtilty.deepCopy(data[0]?.rulesList);             //new variable created auditRuleData to hold the all ruleList and later parent rule assigned to _viewRuleData.
              let auditData = data[0];
              if(this.commonUtilty.isArrayIterable(auditRuleData))
              this.ruleData = this.commonUtilty.deepCopy(auditRuleData[0]);
              
              this._viewRuleData = [auditRuleData[0]];
              this.fetchComputationalSteps(auditData)
            }
            this.tagsList();
            this.transformData();
            this.isLoading = false;
            console.log("viewRuleArr = ", this._viewRuleData);
          },
            err => {
              console.log(err)
            },
            () => {
              console.log('completed')
              this.isLoading = false;
            })
            
      }
    }
  }


  convertTimestampToRegular(updatedDt) { 
     return this.commonUtilty.serverDOtoUIDODate(updatedDt);
  }

  auditHistory = [
    {
      id: 1,
      revision: 4,
      name: 'Health Care Rider Premium Rate',
      tag: 'Current',
      tagColor: 'green',
      date: '5 Sep 2020 11:11 AM (today)',
      remarks: 'Renamed the final launch-ready version without \'v\' in name',
      user: 'Kewal'
    },
    {
      id: 2,
      revision: 3,
      name: 'Health Care Rider Premium v2',
      tag: null,
      tagColor: 'grey',
      date: '5 Sep 2020 11:11 AM (today)',
      remarks: 'Updated rules',
      user: 'Nadia Singh'
    },
    {
      id: 3,
      revision: 2,
      name: 'Health Care Rider Premium v1',
      tag: null,
      tagColor: 'grey',
      date: '5 Sep 2020 11:11 AM (today)',
      remarks: 'Updated rules',
      user: 'Renosh Mehta'
    },
    {
      id: 4,
      revision: 1,
      name: 'Health Care Rider Premium Rate v0.1',
      tag: 'Created',
      tagColor: 'blue',
      date: '1 Sep 2019 11:05 AM (1 year ago)',
      remarks: 'Created basic rule (draft). Needs to be reviewed before launch',
      user: 'Kewal'
    },

  ];

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.viewAuditRuleArr = [];
    this.dataTransformService.expressionQuickView=false;
  }

  isLoading = false;
  selectedItem = this.auditHistory[0];

  selectItem(i) {
    console.log(i)
    this.selectedItem = i;
    this.isLoading = true;
    setTimeout(() => { this.isLoading = false; }, 500);
  }

  ruleRowsList = [];
  noOfConditions = [];
  noOfActions = [];
  transformData() {
    this.ruleRowsList = [];
    this.noOfConditions = [];
    this.noOfActions = [];
    if (this.ruleData && this.commonUtilty.isArrayIterable(this.ruleData.ruleDataList) && this.ruleData.ruleConditionList && this.ruleData.ruleActionList) {
      this.ruleData.ruleDataList.forEach(rule => {
        let ruleRow = { guid: rule.guid, 'ruleColumnsList': [] }
        this.ruleData.ruleConditionList.forEach(ruleCondition => {
          let dataKey = "condition" + ruleCondition.conditionOrder;
          // if (rule[dataKey]) {
          let condition = new RuleDataMapper();
          condition.data = rule[dataKey] ? rule[dataKey] : '-'
          condition.align = typeof condition.data == 'number' ? 'right' : 'left';
          condition.dataType = "CONDITION"
          condition.dataTypeCd = ruleCondition.conditionType;
          condition.dataTypeOrder = ruleCondition.conditionOrder;
          if (ruleCondition.conditionType && (ruleCondition.conditionType.includes("expression") || ruleCondition.conditionType.includes("forLoop"))) {
            condition.columnData = ruleCondition.condition;
            condition.expressionUiCondition = ruleCondition.expressionUiCondition;
          } else {
            condition.columnData = ruleCondition.condition;
          }
          condition['uniqueKey'] = condition.dataTypeCd + condition.columnData
          this.noOfConditions = this.commonUtilty.uniquePushInArray(this.noOfConditions, condition, 'uniqueKey');
          ruleRow.ruleColumnsList.push(condition);
          // }
          let vocabularyDO = this.checkActionInVocabularyList(ruleCondition.condition);
        });
        
        this.ruleData.ruleActionList.forEach(ruleAction => {
          let action = new RuleDataMapper();
          let dataKey = "action" + ruleAction.actionOrder;
          if(this.ruleData.ruleType == 'WORKFLOW'){
            this.ruleEngineService.fetchRuleMetadata_New(this.ruleData.ruleType, this.ruleData.ruleSubType).subscribe(response => {
              if(this.commonUtilty.isArrayIterable(response)){
                response.forEach(resp =>{
                  if(resp.ruleCategory == this.ruleData.ruleCategory){
                    if(this.commonUtilty.isArrayIterable(resp.ruleActionList)){
                      let predefinedAction = resp.ruleActionList.filter(e => e.action === ruleAction.action);
                      if(this.commonUtilty.isArrayIterable(predefinedAction) && predefinedAction.length){
                          let data = predefinedAction[0]
                          if (data.metaData && Object.keys(data.metaData).length) {
                            if (data.metaData && data.metaData.visibleOnUI) {
                              action.data = rule[dataKey] ? rule[dataKey] : '-'
                              action.align = typeof action.data == 'number' ? 'right' : 'left';
                              action.dataType = "ACTION"
                              action.dataTypeCd = data.metaData.actionType;
                              action.dataTypeOrder = data.metaData.actionOrder;
                              action.columnData = data.metaData.labelDescription
                              action['uniqueKey'] = action.dataTypeCd + action.columnData
                              action['labelType'] = data.metaData.labelType
                              this.noOfActions = this.commonUtilty.uniquePushInArray(this.noOfActions, action, 'uniqueKey');
                              ruleRow.ruleColumnsList = this.commonUtilty.uniquePushInArray( ruleRow.ruleColumnsList, action, 'uniqueKey');
                            }
                            else if (data.metaData && !data.metaData.visibleOnUI) {
                            
                            }
                          }
                          else if (!data.metaData) {
                            action.data = rule[dataKey] ? rule[dataKey] : '-'
                            action.align = typeof action.data == 'number' ? 'right' : 'left';
                            action.dataType = "ACTION"
                            action.columnData = ruleAction.action;
                            action['uniqueKey'] = action.dataTypeCd + action.columnData
                            this.noOfActions = this.commonUtilty.uniquePushInArray(this.noOfActions, action, 'uniqueKey');
                            ruleRow.ruleColumnsList = this.commonUtilty.uniquePushInArray( ruleRow.ruleColumnsList, action, 'uniqueKey');
                          }
                          predefinedAction = [];
                      }
                      else {
                        action = this.userDefinedActions(ruleAction, action, rule, dataKey);
                        this.noOfActions = this.commonUtilty.uniquePushInArray(this.noOfActions, action, 'uniqueKey');
                        ruleRow.ruleColumnsList = this.commonUtilty.uniquePushInArray( ruleRow.ruleColumnsList, action, 'uniqueKey');
                      }
                    }
                    else{
                       action = this.userDefinedActions(ruleAction, action, rule, dataKey);
                        this.noOfActions = this.commonUtilty.uniquePushInArray(this.noOfActions, action, 'uniqueKey');
                        ruleRow.ruleColumnsList = this.commonUtilty.uniquePushInArray( ruleRow.ruleColumnsList, action, 'uniqueKey');
                    }
                  }
                })
              }
              else {
                action = this.userDefinedActions(ruleAction, action, rule, dataKey);
                this.noOfActions = this.commonUtilty.uniquePushInArray(this.noOfActions, action, 'uniqueKey');
                ruleRow.ruleColumnsList = this.commonUtilty.uniquePushInArray( ruleRow.ruleColumnsList, action, 'uniqueKey');
              }
              // console.log("Action list fetched based on selected rule type ", response);
            })
          }
          else{
            this.ruleEngineService.fetchRuleMetadata(this.ruleData.ruleType).subscribe(response => {
              if(this.commonUtilty.isArrayIterable(response)){
                response.forEach(resp =>{
                  if(resp.ruleCategory == this.ruleData.ruleCategory){
                    if(this.commonUtilty.isArrayIterable(resp.ruleActionList)){
                      let predefinedAction = resp.ruleActionList.filter(e => e.action === ruleAction.action);
                      if(this.commonUtilty.isArrayIterable(predefinedAction) && predefinedAction.length){
                          let data = predefinedAction[0]
                          if (data.metaData && Object.keys(data.metaData).length) {
                            if (data.metaData && data.metaData.visibleOnUI) {
                              action.data = rule[dataKey] ? rule[dataKey] : '-'
                              action.align = typeof action.data == 'number' ? 'right' : 'left';
                              action.dataType = "ACTION"
                              action.dataTypeCd = data.metaData.actionType;
                              action.dataTypeOrder = data.metaData.actionOrder;
                              action.columnData = data.metaData.labelDescription
                              action['uniqueKey'] = action.dataTypeCd + action.columnData
                              action['labelType'] = data.metaData.labelType
                              this.noOfActions = this.commonUtilty.uniquePushInArray(this.noOfActions, action, 'uniqueKey');
                              ruleRow.ruleColumnsList = this.commonUtilty.uniquePushInArray( ruleRow.ruleColumnsList, action, 'uniqueKey');
                            }
                            else if (data.metaData && !data.metaData.visibleOnUI) {
                            
                            }
                          }
                          else if (!data.metaData) {
                            action.data = rule[dataKey] ? rule[dataKey] : '-'
                            action.align = typeof action.data == 'number' ? 'right' : 'left';
                            action.dataType = "ACTION"
                            action.columnData = ruleAction.action;
                            action['uniqueKey'] = action.dataTypeCd + action.columnData
                            this.noOfActions = this.commonUtilty.uniquePushInArray(this.noOfActions, action, 'uniqueKey');
                            ruleRow.ruleColumnsList = this.commonUtilty.uniquePushInArray( ruleRow.ruleColumnsList, action, 'uniqueKey');
                          }
                          predefinedAction = [];
                      }
                      else {
                        action = this.userDefinedActions(ruleAction, action, rule, dataKey);
                        this.noOfActions = this.commonUtilty.uniquePushInArray(this.noOfActions, action, 'uniqueKey');
                        ruleRow.ruleColumnsList = this.commonUtilty.uniquePushInArray( ruleRow.ruleColumnsList, action, 'uniqueKey');
                      }
                    }
                    else{
                       action = this.userDefinedActions(ruleAction, action, rule, dataKey);
                        this.noOfActions = this.commonUtilty.uniquePushInArray(this.noOfActions, action, 'uniqueKey');
                        ruleRow.ruleColumnsList = this.commonUtilty.uniquePushInArray( ruleRow.ruleColumnsList, action, 'uniqueKey');
                    }
                  }
                })
              }
              else {
                action = this.userDefinedActions(ruleAction, action, rule, dataKey);
                this.noOfActions = this.commonUtilty.uniquePushInArray(this.noOfActions, action, 'uniqueKey');
                ruleRow.ruleColumnsList = this.commonUtilty.uniquePushInArray( ruleRow.ruleColumnsList, action, 'uniqueKey');
              }
              // console.log("Action list fetched based on selected rule type ", response);
            })
          }
          // let dataKey = "action" + ruleAction.actionOrder;
          // // if (rule[dataKey]) {
          // let action = new RuleDataMapper();
          // action.data = rule[dataKey] ? rule[dataKey] : '-'
          // action.align = typeof action.data == 'number' ? 'right' : 'left';
          // action.dataType = "ACTION"
          // action.dataTypeCd = ruleAction.actionType;
          // action.dataTypeOrder = ruleAction.actionOrder;
          // if (ruleAction.metaData && Object.keys(ruleAction.metaData).length) {
          //   if (ruleAction.metaData.visibleOnUI) {
          //     action.columnData = ruleAction.metaData.labelDescription
          //     action['uniqueKey'] = action.dataTypeCd + action.columnData
          //     action['labelType'] = ruleAction.metaData.labelType
          //     this.noOfActions = this.commonUtilty.uniquePushInArray(this.noOfActions, action, 'uniqueKey');
          //     ruleRow.ruleColumnsList.push(action);
          //   }
          //   else if (ruleAction.metaData && !ruleAction.metaData.visibleOnUI) {
              
          //   }
          // }
         
          // else if(!ruleAction.metaData){
          //   action.columnData = ruleAction.action;
          //   action['uniqueKey'] = action.dataTypeCd + action.columnData
          //   this.noOfActions = this.commonUtilty.uniquePushInArray(this.noOfActions, action, 'uniqueKey');
          //   ruleRow.ruleColumnsList.push(action);
          // }
          // }
        });
        this.ruleRowsList.push(ruleRow)
      });
      console.log("noOfConditions", JSON.stringify(this.noOfConditions));
      console.log("noOfActions", JSON.stringify(this.noOfActions));
      console.log("after transform rule data", JSON.stringify(this.ruleRowsList));
    }
  }


  /*Computational related data */

  loading = false;
  pseudoLoad(epoch = 1981986) {
    this.loading = true;
    setTimeout(() => { this.loading = false }, epoch * 5 / 10000);
  }


  allVocabularies = [];
  attributeMap = {};
  dataSelectedConditions
  actionIoType = "IO"
  expressionObject = {
    entityCd: 'expression',
    entity: 'Expression',
    dataTypeCd: 'expression',
    lookupCd: null,
    operator: null,
  }
  dataSelectedActions
  fetchAttributes() {
    this.allVocabularies = this.commonUtilty.deepCopy(this.metadataService.allVocabularies);
    this.attributeMap = this.commonUtilty.convertArrayToMap(this.allVocabularies, 'entityCd');
    this.fetchAndInitializeAllAttributes()
  }

  userDefinedActions(ruleAction, action, rule, dataKey){
    let vocabularyDO = this.checkActionInVocabularyList(ruleAction.action);
    action.data = rule[dataKey] ? rule[dataKey] : '-'
    action.align = typeof action.data == 'number' ? 'right' : 'left';
    action.dataType = "ACTION"
    action.dataTypeCd = ruleAction.actionType;
    action.dataTypeOrder = ruleAction.actionOrder;
    action.columnData = vocabularyDO?.entity
    action['uniqueKey'] = action.dataTypeCd + action.columnData
    action['labelType'] = vocabularyDO?.dataTypeCd == 'COMBO' ? 'LOOKUP' : vocabularyDO?.dataTypeCd
    return action;
  }
  fetchAndInitializeAllAttributes() {
    this.dataAvailable = this.commonUtilty.deepCopy(this.allVocabularies);
    this.attributeMap = this.commonUtilty.convertArrayToMap(this.dataAvailable, 'entityCd');
    this._dataAvailable = this.commonUtilty.deepCopy(this.dataAvailable)
    this.transformServerToUIForList();
    this.RefreshLookups(this.dataSelectedConditions); // give list of lookups
    this.RefreshLookups(this.dataSelectedActions);
  }
  checkActionInVocabularyList(attributeCd){
    let vocabulary = null
    if(this.commonUtilty.isArrayIterable(this.metadataService.allVocabularies)){
      this.metadataService.allVocabularies.forEach(attr =>{
        if(attr.vocabularyCd == attributeCd){
          vocabulary = attr;
          if(vocabulary.dataTypeCd == 'COMBO'){
            this.initializeLookupSubjects([vocabulary.lookupCd]);
          }
        }
      })
    }
      return vocabulary;
  }
 
  transformServerToUIForList() {
    if (this.ruleData) {
      let ruleDO = this.ruleData;
      if (ruleDO && this.commonUtilty.isArrayIterable(ruleDO.ruleConditionList)) {  /*Pre cond  this.commonUtilty.isArrayIterable(this._IO.rulesList[0].ruleConditionList)*/
        this.dataSelectedConditions = this.getTransformedConditions(ruleDO.ruleConditionList); /*this._IO.rulesList[0].ruleConditionList */
        // this.payloadConditionAction.ruleConditionList = this.dataSelectedConditions;
        // this.setRuleConditions();
      }
      if (ruleDO && this.commonUtilty.isArrayIterable(ruleDO.ruleActionList)) { /**this._IO.rulesList[0].ruleActionList */
        // this.setStateConfiguration(ruleDO);
        // this.metaDataConditionActions.stateConfiguration = this.stateConfiguration;
        this.dataSelectedActions = this.getTransaformedActions(ruleDO.ruleActionList);
        // this.payloadConditionAction.ruleActionList = this.dataSelectedActions;
      }
      // this._toggleRefreshComponentForConditionAction()
    }
  }
 
  
  expressionInnerHTMLWithDescription(expression, conditionToCheck) {
    if (conditionToCheck == 'forLoop') {
      let convertString = this.convertJsonToForLoopExpression(expression);
      return this.replaceKeysWithValues(convertString);
    }
    else if (conditionToCheck == 'expression') {
      return this.replaceKeysWithValues(expression);
    }
    else {
      return this.replaceKeysWithValues(expression);
    }
  }
  
  logicalOperatorMap: { [key: string]: string } = {
    "AND": "&&",
    "OR": "||",
    "NOT": "!"
  };

  relationalOperatorMap: { [key: string]: string } = {
  "equals": "==",
  "notEquals": "!=",
  "greaterThan": ">",
  "lessThan": "<",
  "greaterThanOrEquals": ">=",
  "lessThanEquals": "<=",
  "contains":"CONTAINS"
  };

  findConstructs = [
    { key: 'findAny', label: 'FIND ANY' },
    { key: 'findAll', label: 'FIND ALL' },
    { key: 'findMax', label: 'FIND MAX' },
    { key: 'findMin', label: 'FIND MIN' },
    { key: 'findCount', label: 'FIND COUNT' },
    { key: 'findSum', label: 'FIND SUM' },
    { key: 'findAverage', label: 'FIND AVERAGE' }
  ];

  convertJsonToForLoopExpression(jsonString: string): string {
    let json: Expression;
    try {
      json = JSON.parse(jsonString);
    } catch (error) {
      throw new Error("Invalid JSON format");
    }

    const buildConditionString = (condition: any): string => {
      if (!condition) {
        return "";
      }

      const lhs = condition.lhs ?? "";
      const operator = this.relationalOperatorMap?.[condition.relationalOperator] ?? condition.relationalOperator ?? "";
      const rhs = condition.rhs ?? "";

      let nestedConditionString = "";
      if (condition.nestedWhereCondition) {
        const nestedLogicalOperator = condition.nestedWhereCondition.logicalOperator || "";
        nestedConditionString = ` ${this.logicalOperatorMap?.[nestedLogicalOperator] || nestedLogicalOperator} ${buildConditionString(condition.nestedWhereCondition)}`;
      }

      const mainConditionString = `${lhs} ${operator} ${rhs}`.trim();

      return nestedConditionString ? `${mainConditionString}${nestedConditionString}` : mainConditionString;
    };

    const buildExpressionString = (conditions: Array<any>, logicalOperator?: string): string => {
      if (!conditions || !Array.isArray(conditions)) {
        return "";
      }
      const operator = logicalOperator ? (this.logicalOperatorMap?.[logicalOperator] || logicalOperator) : "";
      return conditions.map(buildConditionString).filter(Boolean).join(` ${operator} `);
    };

    const selectedConstruct = this.findConstructs.find(construct => json[construct.key]);
    const findString = selectedConstruct ? `<b>${selectedConstruct.label}</b> ${json[selectedConstruct.key]}` : '';

    const conditionString = buildConditionString(json.whereCondition);
    const logicalOperator = json.whereCondition?.logicalOperator;
    const trueExpression = buildExpressionString(json.ifTrue, logicalOperator);
    const falseExpression = buildExpressionString(json.ifFalse, logicalOperator);

    let expressionHtml = `<b>FOR</b> (${json.parentEntity}) <b>{</b><br>`;

    if (findString) {
      expressionHtml += `  ${findString}<br>`;
    }

    if (conditionString) {
      expressionHtml += `  <b>IF</b> (${conditionString})<br>  <b>{</b>${trueExpression}<b>}</b><br>`;
    }

    if (falseExpression) {
      expressionHtml += `  <b>ELSE</b> <br>  <b>{</b>${falseExpression}<b>}</b><br>`;
    }

    expressionHtml += `<b>}</b>`;

    return expressionHtml;
  }

helperModal: boolean = false
showHelperModal() {
  this.helperModal = true;
}

isNumber(str) {
  var pattern = /^\d+$/;
  return pattern.test(str);  // returns a boolean
}
// @LiquidCache('expressionReplacement{value}', { duration: 18000 })
private replaceKeysWithValues(value) {
  if (this.commonUtilty.isArrayIterable(this.allVocabularies) && value) {
    value = value.replace(/[\u200B-\u200D\uFEFF]/g, ' ');
    let valuesToReplace = this.commonUtilty.splitMulti(value, ["'", ">", "<"])
    valuesToReplace = this.commonUtilty.isArrayIterable(valuesToReplace) ? valuesToReplace.filter(e => e != "" && e && !this.isNumber(e) && (e.startsWith('#VC_') || e.startsWith('#FN_') || (e.startsWith("'") && e.endsWith("'")))) : []

    let lookupValues, functionValues
    try {
      lookupValues = getFromBetween.get(value, "'", "'")
      lookupValues = this.commonUtilty.isArrayIterable(lookupValues)? lookupValues.filter(e => !this.isNumber(e)) : lookupValues
      functionValues = getFromBetween.get(value, "lity'", "'")
    }
    catch { }
    valuesToReplace = this.commonUtilty.uniquePushListInArray(valuesToReplace, lookupValues)
    if (this.commonUtilty.isArrayIterable(functionValues))
      valuesToReplace = valuesToReplace.filter(item => !functionValues.some(d => d == item))
    if (this.commonUtilty.isArrayIterable(valuesToReplace)) {
      valuesToReplace.forEach(valueToReplace => {
        var regex = new RegExp(valueToReplace, "g");
        if (valueToReplace.includes('#VC_'))
          value = value.replace(regex, (this.allVocabulariesMap[valueToReplace] || valueToReplace))
        else if (valueToReplace.includes('#FN_')) {
          value = value.replace(regex, (this.functionTypeMap[valueToReplace] || valueToReplace))
        }
        else if (this.lookupDataService.technicalLabelMap[valueToReplace])
          valueToReplace && (value = value.replace(regex, (this.lookupDataService.technicalLabelMap[valueToReplace] || valueToReplace)))
      });
    }
  }
  return value;
}

allVocabulariesMap = []

private fetchAllVocabularies() {
  let caller: AsyncSubject<any> = new AsyncSubject<any>();
  //this.metadataService.fetchVocabulariesForLOB('ALL').subscribe(resp => {
  let resp = this.commonUtilty.deepCopy(this.metadataService.allVocabularies)
  if (this.commonUtilty.isArrayIterable(resp)) {
    //this.VocabularyRawData = this.commonUtilty.deepCopy(resp);
    this.allVocabularies = resp.map(e => {
      let item = {
        id: e.vocabularyCd,
        itemType: 'VOCABULARY',
        value: e.vocabularyName,
        type: 'default',
        description: e.description,
        metaData: JSON.stringify(e),
        vocabularyMetaData: JSON.stringify(e),
      };
      this.allVocabulariesMap[`#VC_${e.vocabularyCd}`] = e.vocabularyName;
      return item;
    });

    setTimeout(() => {
      caller.next({ status: true });
      caller.complete();
    }, 200);

  }
  return caller
  //});
}

  getTransformedConditions(serverCondition) {
    let uiConditions = []
    if (this.commonUtilty.isArrayIterable(serverCondition)) {
      serverCondition.forEach(element => {
        if (element.conditionType && element.conditionType.includes('expression')) {
          let condObject = this.commonUtilty.deepCopy(this.expressionObject)
          if (condObject) {
            if (element.conditionType == 'expression_from' || element.conditionType == 'expression_to') {
              if (element.conditionType == 'expression_from') {
                condObject['id'] = element.id
                condObject['condition'] = element.condition
                condObject['operator'] = 'RANGE'
                condObject['conditionType'] = element.conditionType
                condObject['expressionUiCondition'] = element.expressionUiCondition
                condObject.operator = 'RANGE'
                uiConditions.push(condObject)
              }
            } else {
              condObject['id'] = element.id
              condObject['condition'] = element.condition
              condObject['conditionType'] = 'expression'  //element.conditionType
              condObject['expressionUiCondition'] = element.expressionUiCondition
              condObject.operator = 'data_variable';
              uiConditions.push(condObject)
            }
          }
        }
        else if (element.conditionType && element.conditionType.includes('forLoop')) {
          let condObject = this.commonUtilty.deepCopy(this.expressionObject)
          if (condObject) {
            if (element.conditionType == 'forLoop_from' || element.conditionType == 'forLoop_to') {
              if (element.conditionType == 'forLoop_from') {
                condObject['id'] = element.id
                condObject['condition'] = element.condition
                condObject['operator'] = 'RANGE'
                condObject['conditionType'] = 'forLoop'
                condObject['expressionUiCondition'] = element.expressionUiCondition
                condObject.operator = 'RANGE'
                uiConditions.push(condObject)
              }
            } else {
              condObject['id'] = element.id
              condObject['condition'] = element.condition
              condObject['conditionType'] = 'forLoop' //element.conditionType
              condObject['expressionUiCondition'] = element.expressionUiCondition
              condObject.operator = element.conditionType == 'forLoop' ? 'data_variable' : 'data_variable;'
              uiConditions.push(condObject)
            }
          }
        }
        else {
          let condObject = this.attributeMap[element.condition]
          if (condObject) {
            if (element.conditionType == 'data_variable_from' || element.conditionType == 'data_variable_to') {
              if (element.conditionType == 'data_variable_from') {
                condObject['id'] = element.id
                condObject.operator = 'RANGE'
                uiConditions.push(condObject)
              }
            } else {
              condObject['id'] = element.id
              condObject.operator = element.conditionType ? element.conditionType : null;
              uiConditions.push(condObject)
            }
          }
          else{
            let condObject = {};
            if (element.conditionType == 'data_variable_from' || element.conditionType == 'data_variable_to') {
              if (element.conditionType == 'data_variable_from') {
                condObject['id'] = element.id
                condObject['operator'] = 'RANGE'
                condObject['description'] = element.condition;
                condObject['entity'] = element.condition;
                condObject['entityCd'] = element.condition;
                condObject['vocabularyCd'] =  element.condition;
                condObject['vocabularyName'] = element.condition;
                condObject['notAvailableInAttributeMap'] = true;
                uiConditions.push(condObject);
              }
            } else {
              condObject['id'] = element.id
              condObject['operator'] = element.conditionType ? element.conditionType : null;
              condObject['description'] = element.condition;
              condObject['entity'] = element.condition;
              condObject['entityCd'] = element.condition;
              condObject['vocabularyCd'] =  element.condition;
              condObject['vocabularyName'] = element.condition;
              condObject['notAvailableInAttributeMap'] = true;
              uiConditions.push(condObject)
            }
          }
        }
      });
      //below code is written for filtering selected Condition Vocabularies from attribute list
      if (this.commonUtilty.isArrayIterable(this._dataAvailable)) {
        uiConditions.forEach(uiConditions => {
          let foundIndex = this._dataAvailable.findIndex(data => data.entityCd == uiConditions.entityCd)
          if (foundIndex != -1)
            this._dataAvailable[foundIndex]['isUsedFlag'] = true
        });
      }
    }
    return uiConditions;
  }

  getTransaformedActions(serverActions) {
    let uiActions = []
    if (this.commonUtilty.isArrayIterable(serverActions)) {
      serverActions.forEach(element => {
        if(!element.metaData){
          let actionObject = this.attributeMap[element.action]
          if (actionObject) {
            actionObject['id'] = element.id
            actionObject.action = element.action
            actionObject.actionOrder = element.actionOrder
            actionObject.actionType = element.actionType
            actionObject.actionIoType = this.actionIoType;
            uiActions.push(actionObject)
          }
        }else{
          uiActions.push(element);
        }
      });
      //below code is written for filtering selected actions Vocabularies from attribute list
      if (this.commonUtilty.isArrayIterable(this._dataAvailable)) {
        uiActions.forEach(uiActions => {
          let foundIndex = this._dataAvailable.findIndex(data => data.entityCd == uiActions.entityCd)
          if (foundIndex != -1)
            this._dataAvailable[foundIndex]['isUsedFlag'] = true
        });
      }
    }
    return uiActions;
  }


  /*In edit mode we need to set action type of rule from ruleActionList  */
  setActionType() {
    if (this.commonUtilty.isArrayIterable(this.computationalRules)) {
      this.computationalRules.forEach(ruleDO => {
        let actionType;
        if (this.commonUtilty.isArrayIterable(ruleDO.ruleActionList)) {
          let ruleAction = ruleDO.ruleActionList.find(item => true)
          if (ruleAction)
            actionType = ruleAction.actionType


          if (ruleDO.ruleActionList[0].actionForCd === "VOCABULARY") {
            ruleDO.radio_select = "VOCABULARY";
          } else {
            ruleDO.radio_select = "VARIABLE";
          }
        }

        switch (actionType) {
          case "constant": {
            ruleDO.step_type = "DTEVALUATION"
            break;
          }
          case "expression": {
            ruleDO.step_type = "EXPRESSIONEVALUATION"
            break;
          }
          case "forLoop": {
            ruleDO.step_type = "EXPRESSIONEVALUATION"
            break;
          }
          case "data_variable": {
            ruleDO.step_type = "ASSIGNMENT"
            break;
          }
          default: {
            break;
          }
        }

      });
    }

  }

  currentControlType: any
  setCurrentControlType(event, step) {
    if (event && step) {
      this.computationalRules.forEach((computationRule, i) => {
        if (step.ruleName == this.computationalRules[i].ruleName)
          if (this.commonUtilty.isArrayIterable(this.computationalRules[i].ruleActionList))
            this.computationalRules[i].ruleActionList[0].actionType = event
      });

    }
  }
  getLookupCdForStep(step) {
    if (step && this.commonUtilty.isArrayIterable(step.ruleActionList)) {
      let ruleAction = step.ruleActionList.find(item => true)
      let vocabName = ruleAction.action
      if (this.metadataService && this.commonUtilty.isArrayIterable(this.metadataService.allVocabularies)) {
        let vocab = this.metadataService.allVocabularies.find(item => item.vocabularyCd == vocabName)
        if (vocab)
          return vocab.lookupCd
      }
    } else {
      console.error("Either step is null or rule action is null", step);
    }

  }

  setRuleDataActionForExpression(event, step) {
    var str = event;
    if (step && str && typeof str == 'string') {
      this.computationalRules.forEach((computationRule, i) => {
        if (step.ruleName == this.computationalRules[i].ruleName)
          if (this.commonUtilty.isArrayIterable(this.computationalRules[i].ruleDataList))
            this.computationalRules[i].ruleDataList[0].action1 = str
      });
    }
  }

  getRuleConditionName(condition, conditionName) {
    let data
    if (condition) {
      if (condition.dataTypeCd && (condition.dataTypeCd.includes('forLoop') || condition.dataTypeCd.includes('expression'))) {
        return 'Expression'
      }
      else return this.technicalTranslatePipe.transform(conditionName)
    }
    else return '-'
  }

  currentVocabulary: any;
  ShowExpressionBuilderViewModal: boolean = false;
  expressionBuilderViewObj: any = {};
  showExpressionDataInModal(condition) {
    this.expressionBuilderViewObj = condition;
    this.ShowExpressionBuilderViewModal = true;
  }

  selectedPreConditionRule: any;
  fetchPreConditionRuleData() {
    // if (this.ruleListData.preConditionRuleCSV) {
    if (this.viewRuleArr && this.commonUtilty.isArrayIterable(this.viewRuleArr)) {
      let preConditionRuleCSV = this.viewRuleArr.find(e => true).preConditionRuleCSV;
      let url = 'masterRuleEngineControllerV2FetchByRuleName/' + preConditionRuleCSV;
      this.apiRequestService.getCallWithAPIMapper(url).subscribe(resp => {
        console.log("pre condition rule data", resp);
        if (resp && this.commonUtilty.isArrayIterable(resp.rulesList)) {
          this.selectedPreConditionRule = resp.rulesList.find(e => true)
          // this.dataTransformService.preConditionRuleForComputation = this.selectedPreConditionRule;
        }
      })
    }
  }

 
  private RefreshLookups(genericList?) {
    let lookupList = [];
    /*Generic approach */
    if (this.commonUtilty.isArrayIterable(genericList)) {
      genericList.forEach(element => {
        if (element.dataTypeCd && element.dataTypeCd == 'COMBO')
          lookupList.push(element.lookupCd);

        if (element.metaData && element.metaData.labelType == 'LOOKUP' && element.metaData.visibleOnUI == true)
          lookupList.push(element.metaData.labelLookupCd);
      });
    }

    if (this.commonUtilty.isArrayIterable(lookupList))
      this.lookup$ = this.initializeLookupSubjects(lookupList);
      console.log("ruleRowsList =",this.ruleRowsList)
  }
  private initializeLookupSubjects(lookupList) {
    if (lookupList && Array.isArray(lookupList))
      lookupList.forEach(field => { this.lookupsToBind = this.commonUtilty.uniquePushInArray(this.lookupsToBind, field); });
    let lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind);
    return lookup$
  }

  fieldDescriptions ={
    "ruleApplicability" : "<div class='m-b-15'>When defining rules, it is important to determine how they should be applied in the system. The Rule Applicability options provide flexibility in specifying the scope and context in which rules will be enforced.</div><h4>Context Specific</h4><div>The 'Context Specific' rule applicability is chosen when a rule is intended for a specific product context. If certain rules need to be evaluated only within specific business contexts such as Product, Coverage, or Benefit, the 'Context Specific' rule applicability is used. Users can select the desired context for rule application.</div><div class='m-t-b-10'>It's important to note that when launching Products, Coverages, and Benefits, the system automatically generates these contexts. This allows for the precise application of rules within the defined contexts, ensuring their relevance and effectiveness in specific business scenarios.</div><h4>Generic</h4><div>The 'Generic' rule applicability is chosen when a rule is intended to be applicable across all products within a selected Line of Business (LOB). This means that the rule will be applied universally to all products within that specific LOB.</div><div class='m-t-b-10'>By selecting the 'Generic' applicability, the rule will be enforced consistently across all applicable products within the chosen LOB, ensuring uniformity and standardization in rule implementation.</div><h4>Product Specific</h4><div>When a rule is only applicable to a specific product, the 'Product Specific' rule applicability is selected. By choosing the 'Product Specific' rule type, the user is required to explicitly map the rule to the corresponding product.</div><div class='m-t-b-10'>This rule applicability ensures that the rule is exclusively enforced for the designated product, allowing for precise customization and tailored rule implementation on a per-product basis. It enables the system to apply product-specific rules accurately, aligning with the unique requirements and characteristics of each individual product.</div>",
    "ruleProccessingType" : "<div>This option allows you to determine the specific sequence in which a rule should be triggered during the evaluation process.</div> <div class='m-t-15'> When configuring rules, it's important to define the order in which they should be triggered and evaluated. This ensures that rules are executed in the desired sequence and that the desired outcomes are achieved. By specifying the sequence of a rule, you can control when it will be triggered relative to other rules in the system. This sequencing helps maintain logical flow and precedence when multiple rules are involved, ensuring accurate rule execution and achieving the intended results.</div> <img class='m-t-15' src='/assets/images/helper-images/rule-processing-type.png' alt='rule-processing-type' />",
  }

  
  showDetailedDescModal: boolean = false;
  selectedField:object = {
  fieldName : null,
  detailedDesc : null
  };
  showDetailedDesc(fieldName, detailedDesc){
    this.selectedField['fieldName'] = fieldName;
    this.selectedField['detailedDesc'] = detailedDesc;
    
    this.showDetailedDescModal = true;
  }

  expressionHTMLText: any;
  getEmittedExpression(expressionText) {
    this.expressionHTMLText = expressionText;
  }

  isCollapsed : boolean = true;
  isComputationStepSectionCollapsed : boolean = false;
  isDTRulesSectionCollapsed : boolean = false;
  isApplicableContextSectionCollapsed : boolean = true;
  togglePanelCollapse(){
    this.isCollapsed = !this.isCollapsed;
  }

  preventDefault(e) {
    e.stopPropagation();
    return false
  }

  fetchRuleName(rulename,versionId){
    this.isView.emit({ ruleName: rulename,versionId:versionId});
  }

  getConditionDisplayName(condition, columnData) {
    if (condition && condition.dataTypeCd && (condition.dataTypeCd.includes('forLoop') || condition.dataTypeCd.includes('expression'))) {
      return 'Expression'
    }
    if (!this.attributeMap || typeof this.attributeMap !== 'object') {
      return columnData;
    }
    for (let key in this.attributeMap) {
      if (this.attributeMap.hasOwnProperty(key)) {
        const attribute = this.attributeMap[key];

        if (attribute && attribute.entityCd === columnData) {
          return attribute.displayName || attribute.vocabularyName ||  columnData;
        }
      }
    }
    return columnData;
  }

  getActionDisplayName(action) {
    if (!this.attributeMap || typeof this.attributeMap !== 'object') {
      return action;
    }
    for (let key in this.attributeMap) {
      if (this.attributeMap.hasOwnProperty(key)) {
        const attribute = this.attributeMap[key];

        if (attribute.vocabularyName === action.columnData) {
          return attribute.displayName || attribute.vocabularyName || action.columnData;
        }
      }
    }
    return action.columnData;
  }

  getComputationRuleDisplayName(action) {
    if (!this.attributeMap || typeof this.attributeMap !== 'object') {
      return action;
    }
    for (let key in this.attributeMap) {
      if (this.attributeMap.hasOwnProperty(key)) {
        const attribute = this.attributeMap[key];

        if (attribute.entityCd === action) {
          return attribute.displayName || attribute.vocabularyName || action;
        }
      }
    }
    return action;
  }
}

var getFromBetween = {
  results: [],
  string: "",
  getFromBetween: function (sub1, sub2) {
    if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
    var SP = this.string.indexOf(sub1) + sub1.length;
    var string1 = this.string.substr(0, SP);
    var string2 = this.string.substr(SP);
    var TP = string1.length + string2.indexOf(sub2);
    return this.string.substring(SP, TP);
  },
  removeFromBetween: function (sub1, sub2) {
    if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
    var removal = sub1 + this.getFromBetween(sub1, sub2) + sub2;
    this.string = this.string.replace(removal, "");
  },
  getAllResults: function (sub1, sub2) {
    // first check to see if we do have both substrings
    if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return;

    // find one result
    var result = this.getFromBetween(sub1, sub2);
    // push it to the results array
    this.results.push(result);
    // remove the most recently found one from the string
    this.removeFromBetween(sub1, sub2);

    // if there's more substrings
    if (this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
      this.getAllResults(sub1, sub2);
    }
    else return;
  },
  get: function (string, sub1, sub2) {
    this.results = [];
    this.string = string;
    this.getAllResults(sub1, sub2);
    return this.results;
  }
};

